import React from 'react'
import ResetPasswordComp from '../components/ResetPasswordComp'

export default function ResetPassword() {
  return (
    <ResetPasswordComp/>
  )
}
